import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { OwnersOverviewPage } from "@/components/owners/owners-overview-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/owners",
  component: OwnersOverviewGuard,
});

function OwnersOverviewGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  // biome-ignore lint/suspicious/noExplicitAny: better-auth user type doesn't expose role
  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <OwnersOverviewPage />;
}
